// extracted by mini-css-extract-plugin
export default {"status":"Status_status__-5Z+m"};